import { PixelRatio } from 'react-native';

const scaleDimension = size => size;
const scale = size => Math.round(PixelRatio.roundToNearestPixel(scaleDimension(size)));
const verticalScale = size => scale(size);

export { scale, verticalScale };
